import React from 'react';
import { QuizModal } from '@portals/quiz-trigger/lib/build/es';
import { useIdleTimer } from 'react-idle-timer';

import { quizFetch } from '#adapter/api/quiz';
import { EQuizID, openQuiz, TIMEOUT_20_SEC_QUIZ } from '#helper/quiz';
import { env } from '#helper/env';
import { qa } from '#adapter/qa';

import '@portals/quiz-trigger/lib/quiz-trigger.css';

export const Quiz = () => {
    useIdleTimer({
        timeout: TIMEOUT_20_SEC_QUIZ,
        events : [
            'click',
            'mousemove',
            'keydown',
            'scroll',
            'mousewheel',
            'wheel',
            'mousedown',
            'touchstart',
            'touchmove',
            'visibilitychange',
            'focus'
        ],
        startOnMount: true,
        onIdle      : () => openQuiz(EQuizID.Timeout20SecQuiz)
    });

    if(env(import.meta.env.APP_QUIZ_DISABLED) || qa.getQuiz()) {
        return;
    }

    return (
        <QuizModal
            useFreeze={true}
            useLocalStorage={false}
            customFetch={quizFetch}
        />
    );
};
